import { isPlatformServer } from '@angular/common';
import { inject, Injectable, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';
import { Request } from 'express';

import { SERVER_REQUEST, WINDOW, ORIGIN_URL_KEY } from '@ppg/core/constants';

@Injectable({ providedIn: 'root' })
export class OriginUrlService {
  readonly #platformId = inject(PLATFORM_ID);
  readonly #transferState = inject(TransferState);
  readonly #serverRequest = inject(SERVER_REQUEST, { optional: true });
  readonly #window = inject(WINDOW, { optional: true });

  private readonly stateKey = makeStateKey<string | null>(ORIGIN_URL_KEY);

  getOriginUrl() {
    if (isPlatformServer(this.#platformId)) {
      const originUrl = this.#serverRequest
        ? `${this.#serverRequest?.protocol}://${this.getUriHost(this.#serverRequest)}`
        : '';
      this.#transferState.set(this.stateKey, originUrl);
      return originUrl;
    } else {
      return this.#transferState.get(this.stateKey, null) ?? this.#window?.location.origin ?? '';
    }
  }

  private getUriHost(req: Request): string | undefined {
    return req.get('x-forwarded-host') ?? req.get('host');
  }
}
